module.exports = __webpack_public_path__ + "static/media/lovely.0db92ef1.jpg";